'use client';

import React from 'react';
import { Receipt, TrendingUp, AlertCircle, Clock, DollarSign, Users } from 'lucide-react';
import { MOCK_SALES, formatUGX } from './salesData';
import { StatCard } from '@/components/ui/Cards';


export default function SalesSummaryCards() {
  const totalRevenue = MOCK_SALES?.reduce((s, r) => s + r?.totalAmount, 0);
  const totalPaid = MOCK_SALES?.reduce((s, r) => s + r?.amountPaid, 0);
  const totalOutstanding = MOCK_SALES?.reduce((s, r) => s + r?.balance, 0);
  const overdueCount = MOCK_SALES?.filter(r => r?.paymentStatus === 'overdue')?.length;
  const overdueAmount = MOCK_SALES?.filter(r => r?.paymentStatus === 'overdue')?.reduce((s, r) => s + r?.balance, 0);
  const uniqueCustomers = new Set(MOCK_SALES.map(r => r.customerId))?.size;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 mb-5">
      <StatCard label="Total Invoiced" value={formatUGX(totalRevenue)} sub="All invoices" icon={Receipt} iconBg="#eff6ff" iconColor="#2563eb" />
      <StatCard label="Amount Collected" value={formatUGX(totalPaid)} sub="Payments received" icon={TrendingUp} iconBg="#f0fdf4" iconColor="#15803d" />
      <StatCard label="Outstanding Balance" value={formatUGX(totalOutstanding)} sub="Across all invoices" icon={DollarSign} iconBg="#fffbeb" iconColor="#d97706" />
      <StatCard label="Overdue Invoices" value={String(overdueCount)} sub={formatUGX(overdueAmount) + ' at risk'} icon={AlertCircle} iconBg="#fef2f2" iconColor="#dc2626" alert={overdueCount > 0} alertVariant="danger" />
      <StatCard label="Pending Payment" value={String(MOCK_SALES?.filter(r => r?.paymentStatus === 'partial' || r?.paymentStatus === 'unpaid')?.length)} sub="Awaiting settlement" icon={Clock} iconBg="#faf5ff" iconColor="#7c3aed" />
      <StatCard label="Active Customers" value={String(uniqueCustomers)} sub="This period" icon={Users} iconBg="#f0fdfa" iconColor="#0f766e" />
    </div>
  );
}
